// translations/pages/landing/it.js

export const landingPageIT = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Soluzioni di IA locali con la protezione dei dati al centro",
    "vision": "Il prossimo livello di produttività: l’Organisation as a Service. I collaboratori IA prendono in carico il lavoro dall’idea al risultato verificato.",
    "intro": "Ricerchiamo, sviluppiamo e integriamo tecnologie di intelligenza artificiale, machine learning ed elaborazione dei dati. Da questo lavoro nascono i nostri prodotti e soluzioni su misura che analizzano, strutturano, anonimizzano e proteggono i dati localmente — e, con [Veridion](veridion), collaboratori IA completamente automatizzati che insieme alle persone assumono interi ambiti di lavoro aziendale.",
    "detail": "Il software che installiamo presso il cliente funziona nella sua infrastruttura e non richiede una connessione al cloud. Documenti, dati e modelli linguistici restano in azienda."
  },
  "partners": {
    "title": "Partner che si affidano a noi",
    "subtitle": "Aziende e istituti di ricerca in cui la nostra organizzazione di IA è operativa in produzione.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nSoluzioni di eye-tracking e biosignali per la vostra ricerca",
        "description": [
          "BiSigma è specializzata in sistemi per la misurazione e l’analisi dei biosegnali e in soluzioni di eye-tracking ad alta precisione per la scienza, la pratica clinica e la ricerca industriale.",
          "pAIoneer Labs GmbH ha sostituito integralmente in BiSigma lo sviluppo software con l’IA, che sviluppa con successo e fa evolvere continuamente il software per la misurazione e l’analisi dei biosegnali."
        ],
        "cta": "Visita BiSigma"
      }
    }
  },
  "products": {
    "title": "Prodotti",
    "subtitle": "Vendiamo software come applicazione desktop per la postazione di lavoro, come software per server on-premises o nel cloud del cliente e in abbonamento sulla nostra piattaforma, ad esempio l’[assistente di trading](finance), che i nostri collaboratori IA sviluppano da sé. Costruiamo inoltre sistemi di IA secondo i requisiti del cliente e offriamo consulenza e formazione.",
    "partnerLabel": "Prodotto partner",
    "priceOnRequest": "Prezzo su richiesta",
    "request": "Invia una richiesta",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil rileva e anonimizza i dati personali nei file Word, Excel, OpenDocument, PDF e di testo, prima che finiscano in strumenti di IA, test, analisi o presso terzi. Il rilevamento combina {presidio}, {spacy} e {flair} e funziona in tedesco, inglese, francese, italiano e spagnolo.",
          "La versione desktop funziona in modo autonomo su comuni computer con Windows, macOS o Linux, senza GPU e senza dipendere dalla rete; i file non lasciano la postazione di lavoro. La versione API viene eseguita nell’infrastruttura del cliente, on-premises o nel cloud di proprietà del cliente, e integra l’anonimizzazione nei sistemi e nei flussi di lavoro esistenti.",
          "La modalità Replace sostituisce i dati personali con segnaposto per la documentazione di conformità, la modalità Fake con valori sostitutivi plausibili per gli ambienti di test; la struttura del documento viene mantenuta. Con AnonChat un documento anonimizzato arriva a ChatGPT, Claude, Gemini o a un modello linguistico interno solo dopo un’anteprima."
        ],
        "cta": "Scopri Kyveil"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Un creatore, infinite soluzioni.",
        "text": [
          "L’IA aziendale della pAIoneer Labs GmbH: dirige l’intera azienda, come organizzazione completa di collaboratori IA con business unit dallo sviluppo software, passando per elettronica e quantum computing, fino a vendite e amministrazione, guidate da un proprio livello di coordinamento.",
          "Questa forza lavoro porta a termine da sola progetti, contabilità, conoscenza aziendale, ricerca, sviluppo e analisi dei dati. La sua comunicazione è ottimizzata dalla teoria dei giochi, e quando le serve una capacità che ancora non esiste, costruisce a questo scopo un proprio sistema di IA.",
          "Funziona on-premises, nel proprio cloud o sulla nostra piattaforma. Lì sviluppa lei stessa l’[assistente di trading](finance) ed è l’IA nella sua chat."
        ],
        "points": [
          "Si integra in ogni processo",
          "Impara da sé",
          "Crea da sé le capacità mancanti",
          "Pianificabile in cicli fissi"
        ],
        "cta": "Scopri Veridion"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy è un sistema di agenti modulare basato sull’IA per le aziende e automatizza le attività amministrative d’ufficio.",
          "Cinque ruoli coprono il lavoro quotidiano: l’assistente coordina gli appuntamenti, redige bozze di e-mail e si occupa delle attività di ogni giorno. Il coach accompagna gli aspetti emotivi e sociali della vita lavorativa, aiuta nei conflitti e sostiene lo sviluppo personale. L’aiutante per la protezione dei dati risponde a domande specialistiche su protezione dei dati e privacy e può essere addestrato su altri ambiti specialistici come la prevenzione incendi o la conformità normativa. Il formatore crea piani di aggiornamento professionale, percorsi di onboarding e moduli formativi, e il consulente analizza i documenti caricati, supporta le decisioni e fornisce raccomandazioni strategiche.",
          "RoBuddy è ospitato e gestito al 100% secondo gli standard tedeschi (GDPR, BSI-Grundschutz) e si collega senza difficoltà a Nextcloud o a qualsiasi unità di rete.",
          "RoBuddy è il sistema agentico per il lavoro d’ufficio e può essere collegato a Veridion per formare un’unica IA aziendale che abbraccia l’intera azienda: RoBuddy si occupa dei compiti alla postazione di lavoro, Veridion collega i sistemi e i dati dell’azienda."
        ],
        "cta": "Scopri RoBuddy",
        "vendorNote": "RoBuddy è un prodotto di Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. È distribuito da pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "Piattaforma SaaS",
    "description": "Usi questa applicazione in abbonamento direttamente nel browser, senza installare nulla. Funziona sulla nostra piattaforma proprietaria, l’accesso richiede un secondo fattore e tutte le chiamate all’IA passano da un unico punto di accesso centrale con quote fisse.",
    "apps": {
      "finance": {
        "name": "Assistente di trading basato sull’IA",
        "text": "Colleghi il tuo conto titoli, fai domande sulle tue posizioni in linguaggio naturale e vedi quali notizie hanno mosso le quotazioni. Per ogni strumento finanziario un modello di machine learning dedicato, riaddestrato ogni giorno, calcola la previsione, e un automatismo può operare sui segnali. L’assistente è sviluppato dai nostri collaboratori IA; nella chat sono anche la sua IA.",
        "cta": "Scopri l’assistente di trading"
      }
    }
  },
  "services": {
    "title": "Servizi principali",
    "veridion": {
      "title": "Collaboratori IA",
      "description": "Interi ambiti di lavoro, presidiati da collaboratori IA che si integrano nei processi e negli strumenti dell’azienda e portano il lavoro a termine da soli. Così lavoriamo noi stessi: la pAIoneer Labs GmbH funziona su questa base.",
      "cta": "Scopri Veridion",
      "features": [
        "Organisation as a Service",
        "Business unit di collaboratori IA",
        "Comunicazione ottimizzata dalla teoria dei giochi",
        "On-premises o cloud proprio"
      ]
    },
    "custom": {
      "title": "Sistemi di IA su misura per i clienti",
      "description": "Sviluppiamo sistemi per l’analisi, l’elaborazione, la strutturazione, l’anonimizzazione e la protezione dei dati secondo i requisiti del cliente e li integriamo in infrastrutture IT locali o di proprietà del cliente.",
      "features": [
        "Funzionamento senza cloud",
        "Sviluppo di prodotti",
        "Prototipi",
        "Progetti di ricerca e sviluppo"
      ]
    },
    "dataanalysis": {
      "title": "Analisi dei dati in conversazione",
      "description": "Un collaboratore IA risponde alle domande rivolte alle fonti di dati collegate. Legge cataloghi, schemi e colonne dei database, presenta un piano di analisi prima di accedere ai dati e chiarisce le ambiguità.",
      "features": [
        "Fonti di dati SQL",
        "Correlazione e regressione",
        "Tabelle e grafici",
        "Esportazione in PDF e PowerPoint"
      ]
    },
    "memory": {
      "title": "Memoria aziendale",
      "description": "Una memoria invece di una ricerca di documenti: fatti, decisioni, attività e procedure, collegati ai progetti, alle persone, ai sistemi e ai documenti a cui appartengono, insieme al tempo in cui valgono. Cresce da sé a partire da conversazioni, riunioni e risultati di lavoro; una decisione più recente sostituisce quella più vecchia sullo stesso tema, nulla va perso.",
      "features": [
        "Grafo di conoscenza",
        "Fatti con riferimento temporale",
        "Decisioni, mai perse",
        "Accesso per competenza"
      ]
    },
    "elektronik": {
      "title": "Elettronica & firmware",
      "description": "Sviluppo vicino all’hardware come servizio: progettazione dei circuiti e simulazione come gemello digitale, firmware fino al sensore, valutazione di componenti e alternative prima della produzione.",
      "features": [
        "Gemelli digitali",
        "Firmware embedded",
        "Analisi dei datasheet",
        "Valutazione dei componenti"
      ]
    },
    "quantum": {
          "title": "LLM Sovrani & IA Quantistica",
          "description": "Il nostro obiettivo sotto Veridion: sviluppare modelli linguistici compatti Made in Germany che competeranno con i grandi modelli di USA e Cina, insieme ai nostri Quantum Transformer.",
          "cta": "Vedi Quantum",
          "features": [
                "LLM Made in Germany",
                "Quantum Transformer",
                "Quantum IDE propria",
                "L'IA sviluppa l'IA"
          ]
    },
    "kyveil": {
      "title": "Anonimizzazione locale senza GPU",
      "description": "Kyveil anonimizza i dati personali in locale, come applicazione desktop su comuni computer con Windows, macOS o Linux oppure come API REST nell’infrastruttura del cliente, senza obbligo di cloud e senza GPU.",
      "cta": "Scopri Kyveil",
      "features": [
        "Anonimizzazione prima dell’IA",
        "Rilevamento delle PII con NLP",
        "Windows, macOS, Linux",
        "API REST on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "Lo sviluppo software assistito dall’IA ha bisogno di un contesto affidabile. L’IDD fissa obiettivi, non-obiettivi, scenari, regole per gli agenti e decisioni come memoria di progetto utilizzabile.",
      "cta": "Scopri l’IDD",
      "features": [
        "Sviluppo agentico",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Scenari come test"
      ]
    },
    "finance": {
      "title": "Finanza e analisi di mercato",
      "description": "Dietro l’assistente di trading sta una business unit dedicata, composta da collaboratori digitali: data scientist IA ed esperti di finanza. Valutano le notizie in tempo reale, analizzano le emozioni delle notizie finanziarie e fanno da sé i calcoli sui dati di mercato nella chat: correlazioni, regressioni, grafici e il bilancio delle proprie previsioni, ogni numero frutto di un passaggio di calcolo eseguito. Alla base lavorano una previsione di machine learning per ogni strumento finanziario e un trading automatico su conto demo e con denaro reale.",
      "cta": "Scopri l’area finanza",
      "features": [
        "Data scientist IA ed esperti di finanza",
        "Notizie in tempo reale, con analisi delle emozioni",
        "Previsione ML per strumento finanziario",
        "Trading automatico"
      ]
    },
    "consulting": {
      "title": "Consulenza",
      "description": "Offriamo consulenza tecnica, organizzativa e strategica per l’introduzione, la messa in sicurezza e l’impiego dell’IA conforme alle norme.",
      "features": [
        "Governance dell’IA",
        "Gestione dei dati",
        "Protezione dei dati",
        "Sicurezza delle informazioni"
      ]
    }
  },
  "contact": {
    "title": "Contatti",
    "addressLabel": "Indirizzo",
    "phoneLabel": "Telefono",
    "emailLabel": "E-mail",
    "cta": "Scrivi un messaggio"
  }
};
